// @flow

import React, {Component} from 'react';
import {I18n} from 'react-redux-i18n';
import {connect} from 'react-redux';
import {filter, size} from 'lodash';
import PropTypes from 'prop-types';
import moment from 'moment';

import {withStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Icon from '@material-ui/core/Icon';
import Badge from '@material-ui/core/Badge';
import ReactGA from 'react-ga';
import {filterHiddensOERs} from '../../app/configuration/util';

import {
  applyFilter,
  updateConstrainedFilters,
  clear,
  clearFilter,
  loadGroups,
  loadOerTypes,
  loadTerminals
} from '../libraryFilterActions';
import Contrained from './ConstrainedFilters';
import DateTimeFilter from './DateTimeFilter';
import MultipleSelectFilter from './MultipleSelectFilter';

const styleSheet = () => ({
  flex: {
    flex: 1
  }
});

export class AbstractLibraryFilters extends Component {
  static propTypes = {
    constrainedFilters: PropTypes.shape({}),
    groupsFilter: PropTypes.arrayOf({}),
    oerTypeFilter: PropTypes.arrayOf({}),
    terminalsFilter: PropTypes.arrayOf({}),
    startTime: PropTypes.number,
    endTime: PropTypes.number,
    mediaId: PropTypes.string
  }

  static defaultProps = {
    constrainedFilters: {},
    groupsFilter: [],
    oerTypeFilter: [],
    terminalsFilter: [],
    startTime: moment().startOf('day').subtract(29, 'days').valueOf(),
    endTime: moment().endOf('day').valueOf(),
    mediaId: ''
  }

  constructor(props) {
    super(props);

    const {
      groupsFilter,
      oerTypeFilter,
      terminalsFilter,
      startTime,
      endTime,
      mediaId
    } = props;

    this.state = {
      open: false,
      groupsFilter,
      terminalsFilter,
      oerTypeFilter,
      startTime,
      endTime,
      mediaId
    };
  }

  componentWillMount() {
    this.props.loadGroups();
    this.props.loadOerTypes();
    this.props.loadTerminals();
  }

  componentWillReceiveProps(props) {
    const {
      oerTypes,
      groupsFilter,
      terminalsFilter,
      oerTypeFilter,
      startTime,
      endTime,
      mediaId
    } = props;

    this.setState({oerTypes});

    // Update state when properties are updates with filter dialog closed
    // e.g. change customer
    if (!this.state.open) {
      this.setState({
        groupsFilter,
        terminalsFilter,
        oerTypeFilter,
        startTime,
        endTime,
        mediaId
      });
    }
  }

  componentDidUpdate = () => {
    if (this.state.open) {
      document.body.classList.add('withdialog');
    } else {
      document.body.classList.remove('withdialog');
    }
  }

  handleOpen = () => {
    this.setState({open: true});

    ReactGA.event({
      category: 'Library Filter',
      action: 'Open Filters',
      label: 'Filters Icon'
    });
  }

  handleRequestClose = () => {
    this.setState({open: false});
  }

  handleOnFilter = () => {
    this.setState({open: false});
    const {
      groupsFilter,
      terminalsFilter,
      oerTypeFilter,
      startTime,
      endTime,
      mediaId
    } = this.state;

    const {constrainedFilters} = this.props;

    this.props.applyFilter({
      chipsFilter: this.props.chipsFilter,
      groupsFilter,
      constrainedFilters,
      terminalsFilter,
      oerTypeFilter,
      startTime,
      endTime,
      mediaId
    });

    ReactGA.event({
      category: 'Library Filter',
      action: 'Apply Filters',
      label: 'Apply Button'
    });
  }

  handleOnClear = () => {
    this.setState({
      open: false,
      groupsFilter: [],
      terminalsFilter: [],
      oerTypeFilter: [],
      startTime: AbstractLibraryFilters.defaultProps.startTime,
      endTime: AbstractLibraryFilters.defaultProps.endTime,
      mediaId: ''
    }, this.applyFilter);

    this.props.updateConstrainedFilters({});

    ReactGA.event({
      category: 'Library Filter',
      action: 'Clear Filters',
      label: 'Clear Button'
    });
  }

  applyFilter = filters => {
    const {
      groupsFilter,
      terminalsFilter,
      oerTypeFilter,
      mediaId,
      startTime,
      endTime
    } = this.state;

    const {chipsFilter} = this.props;

    this.props.applyFilter({
      groupsFilter, terminalsFilter, oerTypeFilter, chipsFilter, mediaId, startTime, endTime, ...filters
    });
  }

  handleGroupSelection = value => {
    this.setState({groupsFilter: value});

    ReactGA.event({
      category: 'Library Filter',
      action: 'Groups',
      label: 'Multiple Select'
    });
  }

  handleTerminalsSelection = value => {
    this.setState({terminalsFilter: value});

    ReactGA.event({
      category: 'Library Filter',
      action: 'Terminals',
      label: 'Multiple Select'
    });
  }

  handleOerSelection = value => {
    this.setState({oerTypeFilter: value});

    ReactGA.event({
      category: 'Library Filter',
      action: 'OER Type',
      label: 'Multiple Select'
    });
  }

  handleDateTime = (dateTime = {}) => {
    this.setState(dateTime);
  }

  filterCount() {
    const {
      groupsFilter,
      constrainedFilters,
      terminalsFilter,
      oerTypeFilter,
      mediaId
    } = this.props;

    const count = size(groupsFilter) +
      size(terminalsFilter) +
      size(oerTypeFilter) +
      size(filter(constrainedFilters, i => i === true))
      + 1 + (mediaId ? 1 : 0);

    return count;
  }

  handleOnBlurMediaId = () => {
    ReactGA.event({
      category: 'Library Filter',
      action: 'Media ID',
      label: 'Filter Chips'
    });
  }

  handleOnChangeMediaId = event => {
    const {value} = event.target;
    this.setState({mediaId: value});
  }

  render() {
    const {classes} = this.props;
    return (
      <div className="viappbar__filtercont">
        <IconButton onClick={this.handleOpen} color="inherit" id="filterIcon">
          <Badge showZero badgeContent={this.filterCount()} className="viappbar__badge-yellow">
            <Icon color="inherit">filter_list</Icon>
          </Badge>
        </IconButton>
        <Dialog
          fullScreen
          open={this.state.open}
          onClose={this.handleRequestClose}
          className="libraryfilter"
        >
          <AppBar className={classes.appBar} color="default">
            <Toolbar>
              <Typography type="title" color="inherit" className={classes.flex} />
              <Button variant="contained" onClick={this.handleOnClear} id="filterClear" className="btn btn-secondary">
                {I18n.t('action.clear')}
              </Button>
              <Button variant="contained" color="primary" className="btn btn-primary" onClick={this.handleOnFilter} id="filterApply">
                {I18n.t('action.apply')}
              </Button>
            </Toolbar>
          </AppBar>
          <List className="librarylist">
            <DateTimeFilter
              onChange={this.handleDateTime}
              startTime={this.state.startTime}
              endTime={this.state.endTime}
            />
            <ListItem id="filterTerminal">
              <MultipleSelectFilter
                options={this.props.terminals}
                label={I18n.t('filter.terminal.label')}
                value={this.state.terminalsFilter}
                onChange={this.handleTerminalsSelection}
              />
            </ListItem>
            <ListItem id="filterGroup">
              <MultipleSelectFilter
                options={this.props.groups}
                label={I18n.t('filter.group.label')}
                value={this.state.groupsFilter}
                onChange={this.handleGroupSelection}
              />
            </ListItem>
            <ListItem id="filterOer">
              <MultipleSelectFilter
                options={this.state.oerTypes}
                label={I18n.t('filter.oer.label')}
                value={this.state.oerTypeFilter}
                onChange={this.handleOerSelection}
              />
            </ListItem>
            <ListItem>
              <TextField
                placeholder={I18n.t('filter.mediaId.label')}
                onBlur={this.handleOnBlurMediaId}
                onChange={this.handleOnChangeMediaId}
                value={this.state.mediaId}
                fullWidth
                id="filterMediaId"
              />
            </ListItem>
            <Contrained />
          </List>
        </Dialog>
      </div>
    );
  }
}

AbstractLibraryFilters.propTypes = {
  classes: PropTypes.shape({}).isRequired
};

function mapStateToProps(state) {
  const {libraryFilters, customer} = state;
  return {
    ...state.i18n.locale,
    customer,
    ...libraryFilters,
    oerTypes: filterHiddensOERs(state)
  };
}

const mapDispatchToProps = dispatch => ({
  applyFilter: filters => dispatch(applyFilter(filters)),
  updateConstrainedFilters: filters => dispatch(updateConstrainedFilters(filters)),
  loadGroups: () => dispatch(loadGroups()),
  loadOerTypes: () => dispatch(loadOerTypes()),
  loadTerminals: () => dispatch(loadTerminals()),
  clearFilter: () => dispatch(clearFilter()),
  clear: () => dispatch(clear())
});

// export default withStyles(styleSheet)(LibraryFilters);
// export default connect(mapStateToProps)(LibraryFilters);
const stylished = withStyles(styleSheet)(AbstractLibraryFilters);
export default connect(mapStateToProps, mapDispatchToProps)(stylished);
